import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { EXECUTION } from '../../../constants/execution-modes';
import { ERROR } from '../../../constants/routes';

export const PauseRoute = ({ children, executionMode, paused, resumed }) => {
    if ((!paused && !resumed) || executionMode !== EXECUTION) {
        return (
            <Navigate
                to={{
                    pathname: ERROR,
                }}
            />
        );
    }

    return children;
};

PauseRoute.propTypes = {
    children: PropTypes.node,
    executionMode: PropTypes.string,
    paused: PropTypes.bool,
    resumed: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        paused: state.status.paused,
        resumed: state.status.resumed,
        executionMode: state.application.executionMode,
    };
};

export default connect(mapStateToProps)(PauseRoute);
